module.exports = __webpack_public_path__ + "img/email-archive.fd73463f.svg";